// Names of the instrument's control.SpatialKitType and spatial.WellLayout proto
// enum values, as stored in SpatialRun.kitType and SpatialRun.wellLayout.
export const KIT_TYPE_TISSUE = "KitTypeTissue";
export const WELL_LAYOUT_ONE_WELL = "OneWell";
export const WELL_LAYOUT_PANOS_SLIDE = "PanosSlide";

// PanosSlide shares the OneWell tile geometry but is a distinct flow cell.
export const isSingleWellLayout = (wellLayout?: string): boolean =>
  wellLayout === WELL_LAYOUT_ONE_WELL || wellLayout === WELL_LAYOUT_PANOS_SLIDE;
